import { medusaSearchByQuery } from '@lib/services/medusa-search.service'
import { LbvProduct } from 'types/experience.type'
import { SearchParameter } from 'types/search.type'
import { create } from 'zustand'

interface MedusaSearchStoreInterface {
  searchResults: LbvProduct[]
  searchCategory: any[]
  isLoadingSearchResults: boolean
  error: string | null
  fetchMedusaSearch: (
    locale: string,
    searchParameters: SearchParameter[]
  ) => Promise<void>
  clearSearchResults: () => void
}

export const useMedusaSearchStore = create<MedusaSearchStoreInterface>(
  (set) => ({
    isLoadingSearchResults: false,
    error: null,
    searchResults: [],
    searchCategory: [],
    fetchMedusaSearch: async (
      locale: string,
      searchParameters: SearchParameter[]
    ) => {
      set({ isLoadingSearchResults: true, error: null })
      try {
        const response = await medusaSearchByQuery(locale, searchParameters)

        set({ searchResults: response.products, isLoadingSearchResults: false })
        set({
          searchCategory: response.categories,
          isLoadingSearchResults: false,
        })
      } catch (error) {
        set({
          error: error instanceof Error ? error.message : 'Unknown error',
          isLoadingSearchResults: false,
        })
      }
    },
    clearSearchResults: () => set({ searchResults: [] }),
  })
)
